<template>
    <div class="fixed-view">
<!--        <div class="first-box cursor">
            <img class="first-box-icon" :src="buy_server_pic" alt="">
            <div>{{ buy_server_text }}</div>
        </div> -->
        <div class="second-box">
            <img class="second-box-icon cursor" :src="qrcode? wei_active_pic: wei_normal_pic" alt="" @mouseover="qrcode = true;kefu_div=false" @mouseleave="qrcode=fasle">
            <div class="line"></div>
            <img class="second-box-icon cursor" style="width: 30px;height: 30px" :src="kefu_div? kefu_active_pic: kefu_pic" alt=""  @mouseover="kefu_div = true;qrcode=false" @mouseleave="kefu_div=fasle">
            <div class="qrcode" v-if="qrcode">
                <img :src="qrcodeUrl" alt="" style="width: 124px;height: 127px;margin-top: 8px;margin-left: 11px;"/>
                <div class="text-center font-12 line-1" style="font-size: 14px;color: #333333;font-weight: bold;">{{ '扫码获取售前支持' }}</div>
            </div>
			<div class="kefu_div" v-if="kefu_div">
				<p style="font-weight: bold;font-size: 15px;color: #333333;height: 9px;">在线客服</p>
				<p style="font-weight: 400;font-size: 12px;color: #888888;width: 121px;">座席专员为您提供专业支持</p>
				<p style="font-weight: bold;font-size: 15px;color: #333333;height: 9px;">建议反馈</p>
				<p style="font-weight: 400;font-size: 12px;color: #888888;width: 121px;">留下您的宝贵意见和建议我们将努力改进</p>
			</div>
        </div>
        <div class="three-box cursor" @click="upClick" v-if="show">
            <img class="three-box-icon" :src="up_pic" alt="">
        </div>
    </div>
</template>
<script>
export default {
    name: 'FixedView',
    props: {
        show: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            buy_server_pic: require('@/assets/home/goumfw-icon.png'),
            buy_server_text: '购买服务',
            wei_normal_pic: require('@/assets/home/wx-icon.png'),
            wei_active_pic: require('@/assets/home/weixin-icon-active.png'),
            kefu_pic: require('@/assets/home/kef-icon.png'),
			kefu_active_pic: require('@/assets/home/kf2.png'),
            up_pic: require('@/assets/home/xshang-icon.png'),
            qrcode: false,
            qrcodeUrl: '',
			kefu_div: false
        }
    },
    mounted() {
		this.fetchWebsiteConfig();
        // QRCode.toDataURL('扫码获取售前支持', {
        //     margin: 2,
        // },(err, url) => {
        //     if (!err) {
        //         this.qrcodeUrl = url;
        //     }
        // });
    },
    methods: {
		async fetchWebsiteConfig() {
			const response = await fetch(this.$apiBaseUrl+"/api/website/website_conf");
			const data = await response.json();
			this.data=data.data
			this.qrcodeUrl=data.data.wx_image
			console.log(data.data)
		},
        upClick() {
            window.scrollTo(0, 0);
        },
    }
}
</script>
<style lang="scss" scoped>
.fixed-view {
    width: 48px;
    height: 340px;
    position: fixed;
    bottom: calc(30vh - 170px);
    right: 30px;
    z-index: 999;
    .first-box {
        width: 18px;
        background: linear-gradient(0deg, #7bb7f5 0%, $theme-color 50%, #7bb7f5 100%);
        border-radius: 8px;
        color: #fff;
        padding: 18px 15px;
        line-height: 1;
        &-icon {
            width: 18px;
            margin-left: -2px;
        }
    }
    .second-box {
        background:#fff;
        border-radius: 8px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 15px 0;
        &-icon {
            width: 30px;
        }
        .line {
            width: 35px;
            height: 1px;
            background: #D4D4D4;
            margin: 15px 0;
        }
        .qrcode {
            height: 172px;
			width: 146px;
            color: #333;
            background: #fff;
            border-radius: 8px;
            position: absolute;
            left: -160px;
            overflow: hidden;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
        }
		.kefu_div{
			width: 146px;
			height: 154px;
			color: #333;
			background: #fff;
			border-radius: 8px;
			position: absolute;
			left: -160px;
			overflow: hidden;
			box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
		}
		.kefu_div p{
			margin-left: 12px;
		}
    }
    .three-box {
        background:#fff;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 9px 0;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
        margin-top: 20px;
        &-icon {
            width: 30px;
            height: 30px;
        }
    }
}
</style>
